export default "__VITE_ASSET__CYJ3e$$f__"